export const registrationSteps = [
  {
    name: 'Personal',
    stepName: '1',
    step: 0,
  },
  {
    name: 'Contacts',
    stepName: '2',
    step: 1,
  },
  {
    name: 'Credentials',
    stepName: '3',
    step: 2,
  },
  {
    name: 'Final',
    stepName: '4',
    step: 3,
  },
];
